import Pagination from '@/model/Pagination';
import Sort from '@/model/SortReq';

export default function (other) {
  other = other || {};
  return {
    // Filter fields
    pixel: other.pixel || null,
    pixelNumber: other.pixelNumber || null,
    pixelToken: other.pixelToken || null,
    agencyName: other.agencyName || null,
    creationTime: other.creationTime || null,

    orgIds: other.orgIds || [],
    buIds: other.buIds || [],

    // Search
    search: other.search || '',

    // Pagination & Sorting
    pagination: other.pagination || Pagination(),
    sort: other.sort || Sort()
  };
}
